<template>
  <div style="min-height: 90vh; padding-top: 120px;">

    <div class="row">
      <div class="col-12 col-lg-10 mx-auto">

        <h1 class="text-center text-color-6">Aviso de Privacidade</h1>

        <div class="bg-white shadow-sm p-5">

          <p>
            Prezado candidato,
            <br><br>
           No <strong class="text-color-6">Cabana Brasil</strong>,  assumimos o compromisso institucional de tratar com muita cautela as informações que utilizamos para a manutenção e expansão do nosso negócio.

            <br><br>
           Informamos que, durante o presente processo seletivo, teremos acesso aos seus dados pessoais coletados pela 99 Jobs, com o objetivo de viabilizar sua candidatura e analisar o seu perfil profissional. Para entender melhor sobre quais dados são coletados pela 99 Jobs e como ela realiza o compartilhamento com as empresas recrutadoras, sugerimos a leitura da sua <a href="https://www.99jobs.com/pages/privacy" target="_blank">Política de Privacidade.</a>
           <br />
           <br />
           Uma vez que você se candidata a uma vaga do Cabana Brasil, nós teremos acesso aos seus dados pessoais cadastrados na plataforma da 99 Jobs e os trataremos da seguinte maneira:
          </p>

          <table width="100%">
            <tbody>

              <tr>
                <td width="200px" class="bg-color-1 p-3 rounded-xl text-white">
                  Quais Dados Pessoais são coletados?
                </td>

                <td class="bg-white p-4">
                  <p>
                    Utilizamos os dados pessoais para finalidades diversas, relacionadas à viabilização de nossos processos de recrutamento, entre elas:
                  </p>
                  <p><arrow-right class="text-color-6" /> Manter comunicação sobre o desenrolar das candidaturas e o prosseguimento dos processos seletivos, seja através de e-mails, mensagens, SMS, telefonemas, dentre outros;</p>
                  <p><arrow-right class="text-color-6" /> Identificar os candidatos durante o processo seletivo;</p>
                  <p><arrow-right class="text-color-6" /> Viabilizar o acesso do candidato às nossas instalações;</p>
                  <p><arrow-right class="text-color-6" /> Analisar o perfil profissional do candidato e sua possível compatibilidade com as vagas disponíveis em nossos processos seletivos;</p>
                  <p><arrow-right class="text-color-6" /> Analisar o perfil do candidato e sua possível aderência aos valores de ética e integridade da companhia, conforme diretrizes de nossos Códigos de conduta. </p>
                </td>
              </tr>

              <tr>
                <td colspan="2" height="10px"></td>
              </tr>

               <tr>
                <td width="200px" class="bg-color-1 p-3 rounded-xl text-white">
                  Quem tem acesso aos Dados Pessoais?
                </td>

                <td class="bg-white p-4">
                  <p>
                    Os dados pessoais serão analisados pelos profissionais responsáveis pela condução do processo seletivo, vinculados à nossa área de Recursos Humanos, bem como pelos gestores responsáveis pela solicitação de contratação.
                  </p>
                </td>
              </tr>

              <tr>
                <td colspan="2" height="10px"></td>
              </tr>

                <tr>
                <td width="200px" class="bg-color-1 p-3 rounded-xl text-white">
                 Como protegemos os Dados Pessoais?
                </td>

                <td class="bg-white p-4">
                  <p>
                    O Cabana Brasil trata com muita cautela as informações que utiliza em suas rotinas. Por isso, implementamos e checamos periodicamente as medidas de segurança que estão ao nosso alcance para proteger os nossos sistemas e bases de dados de acessos não autorizados, bem como de situações acidentais ou ilícitas de destruição, perda, alteração, comunicação ou qualquer forma de tratamento irregular.
Além disso, direcionamos esforços na conscientização de nossos colaboradores acerca da importância do tema proteção de dados, a fim de mantê-los atualizados quanto às melhores práticas de mercado e quanto à importância de implementação de fluxos internos como controle de acesso e dever de confidencialidade.
                  </p>
                </td>
              </tr>

              <tr>
                <td colspan="2" height="10px"></td>
              </tr>

                <tr>
                <td width="200px" class="bg-color-1 p-3 rounded-xl text-white">
                 Por quanto tempo exercemos a retenção dos Dados Pessoais?
                </td>

                <td class="bg-white p-4">
                  <p>
                    A depender do nível de aderência à vaga, podemos armazenar os dados pessoais dos candidatos inscritos em nossos processos seletivos e os manteremos até o encerramento definitivo. Após esse período, os dados pessoais      armazenados serão excluídos, com exceção das informações estritamente necessárias para identificar a participação do candidato, bem como aquelas que sejam úteis ao resguardo de direitos e ao cumprimento de obrigação legal.
                 Além disso, o candidato poderá manifestar interesse na manutenção de seus dados em nossas bases de dados para análise e consideração de seu perfil em processos seletivos futuros.
                  </p>

                </td>
              </tr>

              <tr>
                <td colspan="2" height="10px"></td>
              </tr>

                <tr>
                <td width="200px" class="bg-color-1 p-3 rounded-xl text-white">
                  Quais são os direitos dos titulares de Dados Pessoais?
                </td>

                <td class="bg-white p-4">
                  <p>
                    <br /><br />
                    Como parte de nosso compromisso com a privacidade e a proteção de dados pessoais, garantimos que os direitos sobre os dados pessoais dos candidatos, inclusive aqueles previstos no art. 18 da Lei Federal nº. 13.709/2018 – a Lei Geral de Proteção de Dados, possam ser plenamente exercidos, respeitados os limites aplicáveis. Destacamos os seguintes direitos:
                  </p>
                  <p><strong><arrow-right class="text-color-6" /> 	Confirmação e acesso aos dados: </strong> qualquer um pode requerer a confirmação da existência de tratamento e o acesso aos seus próprios dados pessoais armazenados pelo Cabana Brasil. </p>
                   <p><strong><arrow-right class="text-color-6" /> 	Correção: </strong>   caso os dados pessoais estejam incorretos, imprecisos ou desatualizados, a retificação poderá ser feita mediante solicitação do candidato.       </p>
                        <p><strong><arrow-right class="text-color-6" /> 	Exclusão e oposição: </strong>    o candidato pode solicitar a exclusão ou se opor ao tratamento de seus dados pessoais. Entretanto, é possível que, mesmo após o requerimento, alguns dados pessoais permaneçam armazenados, devido a obrigações legais ou para a proteção de nossos interesses.      </p>
                             <p><strong><arrow-right class="text-color-6" /> 	Portabilidade: </strong>   caso o candidato venha a solicitar a portabilidade de seus dados pessoais, podemos providenciar uma cópia destes em formato de leitura comum.  </p>
                </td>
              </tr>

              <tr>
                <td colspan="2" height="10px"></td>
              </tr>

                <tr>
                <td width="200px" class="bg-color-1 p-3 rounded-xl text-white">
                 Quem é o Controlador de seus dados pessoais?
                </td>

                <td class="bg-white p-4">
                  <p>
A partir do momento no qual executamos o processo de recrutamento e seleção de talentos com base nos dados recebidos e coletados pela 99 Jobs, seremos considerados Controlador de dados pessoais para fins da LGPD. Ou seja, neste momento, o Cabana Brasil será o agente responsável por tomar as decisões referentes ao tratamento das informações pessoais dos candidatos. <br /> <br/>
Complementarmente, a 99 Jobs, assim como o Cabana Brasil, também figura como uma Controladora de dados conforme a LGPD. Isso pelo fato de que a 99 Jobs realiza a coleta dos dados pessoais diretamente com os candidatos, coordena comunicações com os candidatos de acordo com sua Política de Privacidade fornecendo-lhes os meios para que exerçam seus direitos, mantém fundamentação legal própria para o tratamento de dados pessoais e determina quais dados serão coletados e tratados para posterior envio ao Cabana Brasil. <br /> <br/>
Desta forma, as responsabilidades de controlador são divididas entre o Cabana Brasil e a 99 Jobs, de acordo com as etapas de tratamento de dados desempenhadas por cada uma das empresas no processo como um todo.


                  </p>

                </td>
              </tr>

              <tr>
                <td colspan="2" height="10px"></td>
              </tr>


                <tr>
                <td width="200px" class="bg-color-1 p-3 rounded-xl text-white">
                 Quais Bases Legais utilizamos?
                </td>

                <td class="bg-white p-4">
                  <p><strong><arrow-right class="text-color-6" /> Execução Contratual: </strong> Porquanto o candidato e o Cabana Brasil esperam que, ao final do processo, seja formalizada a contratação, será necessário que os dados pessoais fornecidos pelo candidato sejam tratados nas atividades administrativas internas do Cabana Brasil exclusivas para esse fim. </p>
                  <p><strong><arrow-right class="text-color-6" />Interesses Legítimos: </strong> Algumas formas de tratamento dos dados podem envolver situações que necessitem o tratamento de dados pessoais para promover interesses/benefícios legítimos ao candidato e do Cabana Brasil, tornando-se necessário o emprego da base de Legítimo Interesse.  <br /><br /> Quando nos utilizamos desse embasamento, o Cabana Brasil sempre levará em consideração: </p>
                      <p><strong><arrow-right class="text-color-6" />Necessidade: </strong> O tratamento será fundamentado em casos concretos e mensuráveis, onde o uso das informações é essencial para o desempenho do serviço.</p>
                          <p><strong><arrow-right class="text-color-6" /> Proporcionalidade: </strong> Utilizaremos apenas os dados estritamente necessários para o atendimento de interesses legítimos.</p>
                              <p><strong><arrow-right class="text-color-6" /> Salvaguardas: </strong> O candidato poderá acionar o Cabana Brasil, para o exercício de seus direitos. </p>
                                  <p><strong><arrow-right class="text-color-6" /> Obrigações legais: </strong>  O Cabana Brasil também poderá realizar determinados tratamentos quando estes forem necessários para o cumprimento de obrigação legal ou regulatória ou para o exercício regular de direitos em processo judicial, administrativo ou arbitral, durante todo o prazo necessário para tanto. <br /> <br /></p>
                </td>
              </tr>

              <tr>
                <td colspan="2" height="10px"></td>
              </tr>

            </tbody>
          </table>

          <br>

          <p>Em caso de dúvidas, e havendo intenção de exercer qualquer direito sobre suas informações, inclusive aqueles previstos no art. 18 da Lei Federal nº. 13.709/2018 - a Lei Geral de Proteção de Dados -, entre em contato com nossa Equipe de Privacidade, através do canal a seguir:  <a href="https://candidato99jobs.zendesk.com/hc/pt-br" target="_blank">99jobs.cc/meajuda</a> </p>

        </div>
      </div>
    </div>

  </div>
</template>

<script>
  import ArrowRight from "vue-material-design-icons/ArrowRight.vue"

  export default {
    name: 'TermsOfUse',
    components: {
      ArrowRight,
    }
  }
</script>

<style lang="scss" scoped>
  /deep/ .material-design-icon{
    vertical-align: middle;
  }

  @include media-breakpoint-down(md) {
    table tr td{
      display: block;
    }
  }
</style>